import { RestaurantAddRequestStatus, RestaurantDeleteRequestStatus } from "@me-team/host/meBooking/graphql/types";

export const PER_PAGE = 20;

const STATUS_BADGE_CLS = {
    new: "border border-warning-dark text-warning-dark bg-warning-light",
    review: "border border-primary text-primary bg-violet",
    done: "border border-green text-green bg-additional-green",
    rejected: "border border-danger text-danger bg-danger-light",
};

export const ADD_STATUS_BADGE: Record<RestaurantAddRequestStatus, { label: string; cls: string }> = {
    [RestaurantAddRequestStatus.New]: { label: "New", cls: STATUS_BADGE_CLS.new },
    [RestaurantAddRequestStatus.Reviewed]: { label: "Under Review", cls: STATUS_BADGE_CLS.review },
    [RestaurantAddRequestStatus.Contacted]: { label: "Under Review", cls: STATUS_BADGE_CLS.review },
    [RestaurantAddRequestStatus.Approved]: { label: "Processed", cls: STATUS_BADGE_CLS.done },
    [RestaurantAddRequestStatus.Rejected]: { label: "Rejected", cls: STATUS_BADGE_CLS.rejected },
};

export const DELETE_STATUS_BADGE: Record<RestaurantDeleteRequestStatus, { label: string; cls: string }> = {
    [RestaurantDeleteRequestStatus.New]: { label: "New", cls: STATUS_BADGE_CLS.new },
    [RestaurantDeleteRequestStatus.UnderReview]: { label: "Under Review", cls: STATUS_BADGE_CLS.review },
    [RestaurantDeleteRequestStatus.Verified]: { label: "Processed", cls: STATUS_BADGE_CLS.done },
    [RestaurantDeleteRequestStatus.Processed]: { label: "Processed", cls: STATUS_BADGE_CLS.done },
    [RestaurantDeleteRequestStatus.Rejected]: { label: "Rejected", cls: STATUS_BADGE_CLS.rejected },
};
